import { render, staticRenderFns } from "./ledger-data-summarization.vue?vue&type=template&id=7c28ca98&scoped=true&"
import script from "./ledger-data-summarization.vue?vue&type=script&lang=js&"
export * from "./ledger-data-summarization.vue?vue&type=script&lang=js&"
import style0 from "./ledger-data-summarization.vue?vue&type=style&index=0&id=7c28ca98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c28ca98",
  null
  
)

export default component.exports